import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';
import logger from '../../utils/logger';

class KYCService {
  fetchKYCRecords = async ({
    page = 1,
    limit = 10,
    kycId = '',
    name = '',
    kycType = '',
    fromDate = null,
    toDate = null,
    status = '',
  } = {}) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);

    if (kycId !== '' && kycId !== null && kycId !== undefined) {
      const id = String(kycId).trim();
      if (id) params.set('kycId', id);
    }
    if (name && String(name).trim()) {
      params.set('name', String(name).trim());
    }
    if (kycType) params.set('kycType', kycType);
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    if (status) params.set('status', status);

    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/v1/user/kyc/all?${params.toString()}`,
      );
      // console.log('Raw API response:', response.data);
      return response.data;
    } catch (error) {
      logger.error('Error fetching KYC records:', error);
      throw error;
    }
  };

  fetchKYCByUserId = async (userId) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/v1/user/kyc/user/${userId}`,
      );
      return response.data;
    } catch (error) {
      logger.error('Error fetching KYC by user ID:', error);
      throw error;
    }
  };

  approveRejectKYC = async (kycId, approved, rejectReason = null) => {
    try {
      const payload = {
        kycId: parseInt(kycId),
        rejectReason: '',
        approved,
      };

      if (!approved) {
        payload.rejectReason = rejectReason || '';
      }

      const response = await axiosInstance.post(
        `${BASE_URL}/v1/user/kyc/approve-reject`,
        payload,
      );
      return response.data;
    } catch (error) {
      logger.error('Error updating KYC:', error);
      throw error;
    }
  };
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new KYCService();
